import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import { popUpMessageChange,
        responseDataChange,
        selectedCardsGroupsChange,
        popUpMenuChange } from '../../actions/index'

import CloseIcon from '@material-ui/icons/Close';

class CloseButton extends React.Component{

    handleCloseChange = () => {
        this.props.popUpMessageChange({ show: false })
        this.props.responseDataChange({})
        if (this.props.closeConfirmation) {
            this.props.selectedCardsGroupsChange([]);
        }
    }

    render(){   
        return (
            <div>
                <div className="close-button-message" onClick={ this.handleCloseChange }>
                    <CloseIcon/>
                </div>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        popUpMessageChange : popUpMessageChange,
        responseDataChange : responseDataChange,
        selectedCardsGroupsChange : selectedCardsGroupsChange,
        popUpMenuChange : popUpMenuChange
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(CloseButton)